import request from './requestWrapper';


function decryptTempToken(code: string) {
  return request({
    url: 'auth/decryptTempToken',
    method: 'POST',
    data: { c: code },
  });
}

export default {
  decryptTempToken
}